export interface Country {
  code: string;
  name: string;
  currency: string;
  currencySymbol: string;
  phoneCode: string;
}

export const COUNTRIES: Country[] = [
  { code: 'RW', name: 'Rwanda', currency: 'RWF', currencySymbol: 'FR', phoneCode: '+250' },
  { code: 'KE', name: 'Kenya', currency: 'KES', currencySymbol: 'KSh', phoneCode: '+254' },
  { code: 'UG', name: 'Uganda', currency: 'UGX', currencySymbol: 'USh', phoneCode: '+256' },
  { code: 'TZ', name: 'Tanzania', currency: 'TZS', currencySymbol: 'TSh', phoneCode: '+255' },
  { code: 'BI', name: 'Burundi', currency: 'BIF', currencySymbol: 'FBu', phoneCode: '+257' },
  { code: 'CD', name: 'DR Congo', currency: 'CDF', currencySymbol: 'FC', phoneCode: '+243' },
  { code: 'ET', name: 'Ethiopia', currency: 'ETB', currencySymbol: 'Br', phoneCode: '+251' },
  { code: 'GH', name: 'Ghana', currency: 'GHS', currencySymbol: 'GH₵', phoneCode: '+233' },
  { code: 'NG', name: 'Nigeria', currency: 'NGN', currencySymbol: '₦', phoneCode: '+234' },
  { code: 'CI', name: "Côte d'Ivoire", currency: 'XOF', currencySymbol: 'CFA', phoneCode: '+225' },
  { code: 'SN', name: 'Senegal', currency: 'XOF', currencySymbol: 'CFA', phoneCode: '+221' },
  { code: 'ZA', name: 'South Africa', currency: 'ZAR', currencySymbol: 'R', phoneCode: '+27' },
  { code: 'ZM', name: 'Zambia', currency: 'ZMW', currencySymbol: 'ZK', phoneCode: '+260' },
  { code: 'MW', name: 'Malawi', currency: 'MWK', currencySymbol: 'MK', phoneCode: '+265' },
  { code: 'MZ', name: 'Mozambique', currency: 'MZN', currencySymbol: 'MT', phoneCode: '+258' },
  { code: 'MA', name: 'Morocco', currency: 'MAD', currencySymbol: 'MAD', phoneCode: '+212' },
  { code: 'EG', name: 'Egypt', currency: 'EGP', currencySymbol: 'E£', phoneCode: '+20' },
  { code: 'US', name: 'United States', currency: 'USD', currencySymbol: '$', phoneCode: '+1' },
  { code: 'GB', name: 'United Kingdom', currency: 'GBP', currencySymbol: '£', phoneCode: '+44' },
  { code: 'FR', name: 'France', currency: 'EUR', currencySymbol: '€', phoneCode: '+33' },
  { code: 'DE', name: 'Germany', currency: 'EUR', currencySymbol: '€', phoneCode: '+49' },
  { code: 'IN', name: 'India', currency: 'INR', currencySymbol: '₹', phoneCode: '+91' },
  { code: 'CN', name: 'China', currency: 'CNY', currencySymbol: '¥', phoneCode: '+86' },
  { code: 'BR', name: 'Brazil', currency: 'BRL', currencySymbol: 'R$', phoneCode: '+55' },
];

export const getCountryByCode = (code: string): Country | undefined =>
  COUNTRIES.find((c) => c.code === code);

export const getCurrencyForCountry = (code: string): string =>
  getCountryByCode(code)?.currency || 'RWF';

export const getCurrencySymbolForCountry = (code: string): string =>
  getCountryByCode(code)?.currencySymbol || 'FR';
